import ConsultaAPI from '../components/ConsultaAPI';

export default function Home() {
  return <ConsultaAPI />;
}
